"use client";
import { motion } from "framer-motion";
import ContactForm from "../../app/(public)/contact/_components/contact-form";

export function ContactSection() {
  return (
    <section className="py-24 bg-muted/20" aria-labelledby="contact-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2
            id="contact-heading"
            className="font-serif text-3xl md:text-4xl font-light tracking-tight mb-6"
          >
            Contact Us
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg leading-relaxed">
            Have a project in mind? Our team can help with specification, sample
            requests, and certified applicator recommendations.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="max-w-2xl mx-auto mt-4"
        >
          <ContactForm />
        </motion.div>
      </div>
    </section>
  );
}
